
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/step/pricing",
      function () {
        return require("private-next-pages/android/step/pricing.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/step/pricing"])
      });
    }
  